export const SET_ADDRESS = "SET_ADDRESS";
export const SET_NEW_ADDRESS = "SET_NEW_ADDRESS";
export const SET_ADDRESSES = "SET_ADDRESSES";
export const SET_IS_FETCHING_DATA = "SET_IS_FETCHING_DATA";
